import { render, staticRenderFns } from "./Scenario.vue?vue&type=template&id=3086680a&lang=pug"
import script from "./Scenario.vue?vue&type=script&lang=ts"
export * from "./Scenario.vue?vue&type=script&lang=ts"
import style0 from "./Scenario.vue?vue&type=style&index=0&id=3086680a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports